let audioUnlocked = false;
let unlockInstalled = false;

function markUnlocked() {
  audioUnlocked = true;
}

export function isAudioUnlocked(): boolean {
  return audioUnlocked;
}

export function setupAudioUnlock(): void {
  if (unlockInstalled || audioUnlocked) return;
  const tryUnlock = async () => {
    try {
      const el = new Audio('/sounds/popup.wav');
      el.volume = 0;
      el.loop = false;
      try { await el.play(); } catch {}
      try { el.pause(); } catch {}
      try { el.currentTime = 0; } catch {}
      markUnlocked();
    } catch {}
    cleanup();
  };
  const cleanup = () => {
    window.removeEventListener('pointerdown', tryUnlock, true);
    window.removeEventListener('keydown', tryUnlock, true);
    window.removeEventListener('touchstart', tryUnlock, true);
  };
  window.addEventListener('pointerdown', tryUnlock, true);
  window.addEventListener('keydown', tryUnlock, true);
  window.addEventListener('touchstart', tryUnlock, true);
  unlockInstalled = true;
}

// Prosty odtwarzacz dźwięków powiadomień z throttlingiem
let notifyEl: HTMLAudioElement | null = null;
let lastNotifyAt = 0;
export async function playNotify(): Promise<void> {
  try {
    const now = Date.now();
    if (now - lastNotifyAt < 750) return; // gardło na duble eventów
    lastNotifyAt = now;
    if (!notifyEl) {
      notifyEl = new Audio('/sounds/popup.wav');
      notifyEl.loop = false;
      notifyEl.volume = 0.6;
    }
    try { notifyEl.pause(); } catch {}
    try { notifyEl.currentTime = 0; } catch {}
    await notifyEl.play();
  } catch {
    // brak akcji; w Safari przed odblokowaniem może się nie udać
  }
}


